export const PAYMENT_PROVIDERS_REQUIRED_BILLING_DETAILS = [OLO.Enums.PAYMENT_PROVIDER.FAT_ZEBRA, OLO.Enums.PAYMENT_PROVIDER.CARD_CONNECT] as const;

export const PAYMENT_PROVIDERS_WITH_CVV_VALIDATION = [OLO.Enums.PAYMENT_PROVIDER.ADYEN, OLO.Enums.PAYMENT_PROVIDER.CARD_CONNECT] as const;

export const CARDLESS_PAYMENT_TYPES = [OLO.Enums.PAYMENT_VENDOR_SERVICE.ACCOUNT_CHARGE, OLO.Enums.PAYMENT_VENDOR_SERVICE.PAY_IN_STORE] as const;
